const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Fitzroy: menu push. When the Fitzroy menu opens, the page slides down below the
   menu links instead of the links sitting on top of the page. Remove this block to undo. */
(function () {
  var css =
    'body{transition:padding-top .3s ease;}' +
    '.fitzroy-menu__panel{position:absolute !important;bottom:auto !important;overflow:visible !important;}' +
    'body.fitzroy-menu-open{overflow:auto !important;}' +
    'body .fitzroy-menu .fitzroy-menu__link{color:rgb(var(--color-foreground)) !important;}';

  function init() {
    var menu = document.querySelector('fitzroy-menu');
    var panel = menu && menu.querySelector('.fitzroy-menu__panel');
    var main = document.getElementById('MainContent');
    if (!menu || !panel || !main) return;

    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    // Where the page content starts with no push applied. Subtracts any push
    // currently on the page, so a mid-animation measurement is still correct.
    function contentTop() {
      var current = parseFloat(getComputedStyle(document.body).paddingTop) || 0;
      return main.getBoundingClientRect().top + window.scrollY - current;
    }

    function update() {
      if (menu.classList.contains('is-open')) {
        var push = panel.offsetHeight - contentTop() + 16;
        document.body.style.paddingTop = Math.max(0, push) + 'px';
      } else {
        document.body.style.paddingTop = '';
      }
    }

    new MutationObserver(update).observe(menu, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
